/* unplugin-vue-components disabled */import script from "./productDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./productDetail.vue?vue&type=script&lang=ts&setup=true"

import "./productDetail.vue?vue&type=style&index=0&id=0ccd50d0&lang=scss&scoped=true"
import "./productDetail.vue?vue&type=style&index=1&id=0ccd50d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccd50d0"]])

export default __exports__